import { Link, Typography } from "@mui/material";
import { useSocialTermsDocuments } from "Components/Social/SocialTermsConsent/useSocialTermsDocuments";
import { Trans } from "react-i18next";
import { Resources, getResourcePath } from "Translations/Resources";

const RESOURCES = Resources.Social.Terms;

const NEW_TAB = { target: "_blank", rel: "noopener noreferrer" } as const;

/**
 * Label of the consent checkbox: one sentence naming the three accepted documents, each a link
 * opening the PDF in a new tab.
 */
export const SocialTermsCheckboxLabel = () => {
  const { terms, chatTerms, communityRules } = useSocialTermsDocuments();

  return (
    <Typography>
      <Trans
        i18nKey={getResourcePath(RESOURCES.CheckboxLabel)}
        components={{
          terms: <Link href={terms.url} {...NEW_TAB} />,
          chatTerms: <Link href={chatTerms.url} {...NEW_TAB} />,
          communityRules: <Link href={communityRules.url} {...NEW_TAB} />,
        }}
      />
    </Typography>
  );
};
